// extracted by mini-css-extract-plugin
export default {"container":"kda-z","heading":"lda-z","links":"mda-z","linkBtn":"nda-z","disabled":"oda-z","linkUppercaseBold":"pda-z","copy":"qda-z","subCopy":"rda-z"};